import gql from 'graphql-tag';

export default gql`
    query GetDemobDetails($input: GetDemobDetailsInput) {
       getDemobDetails(input: $input) {
            stats {
                assetTypeId
                assetType
                plannedQty
                availableQty
                created
                readyForDispatch
                inRoute
                delivered
                actualQty
                additionalNeeded
            }
            jobInfo {
                mobStatus
                mobDate
                mobEndDate
                leapFrog
            }
        }
    }
`;
